import getHostVariables from './getHostVariables';
import {COMPONENT_ID} from '../symbols';
import {SEISMIC_HOIST_TAG_NAME} from '../constants';

export default function getRootNode(node) {
	const rootNode = node.getRootNode();

	if (rootNode.host && rootNode.host.tagName === SEISMIC_HOIST_TAG_NAME)
		return rootNode.host.sourceElement;

	if (rootNode !== document) return rootNode.host;

	if (node.assignedSlot) return getRootNode(node.assignedSlot);

	let {parentNode} = node;
	while (parentNode !== document.body) {
		const parentVariables = getHostVariables(parentNode);

		if (parentVariables && parentVariables[COMPONENT_ID]) return parentNode;

		parentNode = parentNode.parentNode; // eslint-disable-line prefer-destructuring
	}

	return null;
}
